import React from "react";
import { formatCurrency, formatPercent } from "./ctf-shared-utils";

/**
 * Summary section at the top of the table
 * Displays key pricing metrics and aircraft details
 * Updated for ClickToFlyResult model structure
 */
const TableSummarySection = ({
  aircraft,
  calculatedPrice,
  totalDiscount,
  estimateDoc,
  tripType,
}) => {
  // Calculate markup % from estimate final price to default price
  const estimateFinalPrice = aircraft.estimateFinalPrice || aircraft.defaultPrice;
  const markupPercent =
    estimateFinalPrice > 0
      ? (aircraft.defaultPrice - estimateFinalPrice) / estimateFinalPrice
      : 0;

  return (
    <div className="ctf-table-summary">
      <div className="summary-grid">
        <div className="summary-item">
          <label>Aircraft</label>
          <span className="value">{aircraft.aircraftTypeName}</span>
        </div>

        <div className="summary-item">
          <label>Seats</label>
          <span className="value">
            {aircraft.seatCount ? aircraft.seatCount : "N/A"}
          </span>
        </div>

        {estimateDoc?.distance && (
          <div className="summary-item">
            <label>Distance</label>
            <span className="value">{Math.ceil(estimateDoc.distance)} NM</span>
          </div>
        )}

        <div className="summary-item">
          <label>Pricing Method</label>
          <span className="value">
            {tripType === 1 ? "ONE-WAY" : "ROUND-TRIP"}
          </span>
        </div>

        <div className="summary-item">
          <label>Low Spread</label>
          <span className="value">
            {formatCurrency(estimateFinalPrice * 0.75)}
          </span>
        </div>

        <div className="summary-item">
          <label>High Spread</label>
          <span className="value">
            {formatCurrency(estimateFinalPrice * 1.02)}
          </span>
        </div>

        <div className="summary-item">
          <label>Final Price (Estimate)</label>
          <span className="value">{formatCurrency(estimateFinalPrice)}</span>
        </div>

        <div className="summary-item">
          <label>Markup to Default</label>
          <span className="value">{formatPercent(markupPercent)}</span>
        </div>

        <div className="summary-item ctf-price">
          <label>Default Price</label>
          <span className="value">{formatCurrency(aircraft.defaultPrice)}</span>
        </div>

        <div className="summary-item">
          <label>Max Discount</label>
          <span className="value">
            {formatPercent(aircraft.theoreticalMaxDiscount?.percent || 0)}
          </span>
        </div>

        <div className="summary-item ctf-price">
          <label>Starting From</label>
          <span className="value">
            {formatCurrency(
              aircraft.theoreticalMaxDiscount?.lowestPossiblePrice ||
                aircraft.defaultPrice
            )}
          </span>
        </div>

        <div className="summary-item">
          <label>Your Calculated Price</label>
          <span className="value">{formatCurrency(calculatedPrice)}</span>
        </div>

        {totalDiscount.percent !== 0 && (
          <div className="summary-item">
            <label>Total Adjustment</label>
            <span className="value">
              {formatPercent(totalDiscount.percent)}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TableSummarySection;
